import React, { Component } from "react";
import { Container, Row, Col, Button } from 'reactstrap';
import Slider from "react-slick";
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const TestimonialDesktopsettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
};

const TestimonialMobilesettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
};



export default class TestimonialPanelNew extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { items } = this.props;

        const testimonialdonorsdesktop = items.map((item, index) => (
            <div style={{ padding: '1rem' }} key={index}>
                <div className="pointer-home" style={{}}>
                    <Row>
                        <Col md="6" sm="12" xs="12" lg="5" className="d-flex justify-content-center align-self-center" >
                            <img style={{ width: '100%' }} src={`${config.cdnUrl}${item.urlimage}`} alt={item.altText} className="testimonial-quotessss" loading="lazy"/>
                        </Col>
                        <Col md="6" sm="12" xs="12" lg="7">
                            <h2 className="testimonial-heading" >What our beneficiaries say</h2>
                            <p className="testimonial-description">{item.description}</p>
                            <p className="testimonal-cta-desc">{item.ctatext}</p>
                            <a href={item.ctalink}
                                onClick={() => {
                                    const eventInfo = {
                                        name : item.cta 
                                    };
                                    if (window.eventDispatcher) {
                                        window.eventDispatcher.dispatchEventSync('testimonial-cta', eventInfo, { amplitude: true });
                                    }
                                }} className="">
                                <Button style={{ width: 'auto' }} color="primary" className="btn-full-width btn  btn-primary">
                                    {item.cta}
                                </Button>
                            </a>
                        </Col>
                    </Row>
                </div>
            </div>
        ));
        const testimonialDonorsMobile = items.map((item, index) => (
            <div style={{ padding: '1rem' }} key={index}>
                <div className="" style={{ padding: '0rem .5rem 0rem .5rem' }}>
                    <Row>
                        <img
                            style={{ width: '100%' }}
                            src={`${config.cdnUrl}${item.urlimage}`}
                            className="testimonial-quotessss"
                            loading="lazy"
                        />
                        <p className="testimonial-description">{item.description}</p>
                        <p className="testimonal-cta-desc">{item.ctatext}</p>
                        <a href={item.ctalink}
                            onClick={() => {
                                const eventInfo = {
                                    name : item.cta 
                                };
                                if (window.eventDispatcher) {
                                    window.eventDispatcher.dispatchEventSync('testimonial-cta', eventInfo, { amplitude: true });
                                }
                            }} className="w-100">
                            <Button style={{ marginBottom: '1.5rem' }} color="primary" className="btn-full-width btn  btn-primary">
                                {item.cta}
                            </Button>
                        </a>
                    </Row>
                </div>
            </div>
        ));

        return (

            <Container fluid style={{ padding: '0px', marginTop: '1rem', marginBottom: '2rem' }}>
                <div className="testimonial-home-box">
                    <div className=" hide-for-mobile testimonial-slider-dots testimonial-slick-arrow" style={{ padding: '1rem' }}>
                        <Slider {...TestimonialDesktopsettings} className="btn-slider">
                            {testimonialdonorsdesktop}
                        </Slider>
                    </div>
                    <div className=" hide-for-desktop testimonial-slider-dots testimonial-slider-dots-mobile testimonial-slick-arrow-moble"
                        style={{}}>
                        <h2 className="testimonial-heading" >What our beneficiaries say</h2>
                        <Slider {...TestimonialMobilesettings} className="btn-slider">
                            {testimonialDonorsMobile}
                        </Slider>
                    </div>
                </div>
            </Container>
        );
    }
}

